// Runs the TMDB library sweep once and exposes the enriched stats + progress,
// so multiple dashboard components (taste signature, Deep focus) share a single
// pass instead of each triggering their own.

import { useEffect, useState } from "react";
import type { DistilledProfile } from "./types.ts";
import { computeEnrichedStats, type EnrichedStats } from "./enrich.ts";

export interface EnrichedState {
  stats: EnrichedStats | null;
  progress: { done: number; total: number };
}

export function useEnrichedStats(profile: DistilledProfile): EnrichedState {
  const [stats, setStats] = useState<EnrichedStats | null>(null);
  const [progress, setProgress] = useState({ done: 0, total: 0 });

  useEffect(() => {
    let cancelled = false;
    setStats(null);
    computeEnrichedStats(profile, {
      onProgress: (done, total) => !cancelled && setProgress({ done, total }),
    }).then((s) => {
      if (!cancelled) setStats(s);
    });
    return () => {
      cancelled = true;
    };
  }, [profile]);

  return { stats, progress };
}
